module.exports = __webpack_public_path__ + "img/sleep.99feb24e.jpg";